.banner {
  position: relative;
  z-index: 1300;
}
